import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorMessage, RouteLeavingConfigs, SettingsState } from 'app/settings/types';

const initialState: SettingsState = {
  successMessage: '',
  errorMessage: { status: null, errors: [] },
  breadcrumbParams: {},
  activeMenu: 0,
  pageLoading: false,
  endedStatus: false,
  routeLeavingConfigs: {
    showPrompt: false,
    confirmNavigation: () => {},
    cancelNavigation: () => {},
  },
  generateReportEndedStatus: false,
  noAccess: false,
};

const slice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setActiveMenu: (state, action: PayloadAction<number>) => {
      state.activeMenu = action.payload;
    },
    setBreadCrumbParams: (state, action: PayloadAction<{key: string, value: string}>) => {
      const { key, value } = action.payload;
      state.breadcrumbParams[key] = value;
    },
    resetBreadCrumbParams: (state) => {
      state.breadcrumbParams = {};
    },
    changeLoadingState: (state, action: PayloadAction<boolean>) => {
      state.pageLoading = action.payload;
    },
    setSuccessMessage: (state, action: PayloadAction<string>) => {
      state.successMessage = action.payload;
    },
    setErrorMessage: (state, action: PayloadAction<ErrorMessage>) => {
      state.errorMessage = action.payload;
    },
    resetMessage: (state) => {
      state.errorMessage = { status: null, errors: [] };
      state.successMessage = '';
    },
    changeEndedStatus: (state, action: PayloadAction<boolean>) => {
      state.endedStatus = action.payload;
    },
    changeRouteLeavingConfigs: (state, action: PayloadAction<RouteLeavingConfigs>) => {
      state.routeLeavingConfigs = action.payload;
    },
    changeGenerateReportEndedStatus: (state, action: PayloadAction<boolean>) => {
      state.generateReportEndedStatus = action.payload;
    },
    setNoAccess: (state, action: PayloadAction<boolean>) => {
      state.noAccess = action.payload;
    },
  },
});

export const {
  setActiveMenu, setBreadCrumbParams, resetBreadCrumbParams, changeLoadingState, setErrorMessage, setSuccessMessage, resetMessage,
  changeEndedStatus,
  changeGenerateReportEndedStatus,
  changeRouteLeavingConfigs,
  setNoAccess,
} = slice.actions;

export default slice.reducer;
